
import React from 'react';
import '../App.css';

function Vision() {
  return (
    <section id="vision">
      <div className="content">
        <h2 className="junaeb-title">Visión</h2>
        <div className="glass-card">
          <p>
            Aspiramos a constituirnos en una comunidad educativa democrática, tolerante y respetuosa, 
            que considera la realidad sociocultural de estudiantes y familias, para promover la creatividad 
            y el respeto por el entorno, mediante experiencias educativas innovadoras, desafiantes y 
            contextualizadas, aportando a la formación subjetiva e identitaria de NNA.
          </p>
        </div>
      </div>

      <style jsx>{`
        /* Tarjeta con efecto vidrio */
        .glass-card {
          background: rgba(0, 0, 0, 0.35); /* transparente y elegante */
          border-radius: 16px;
          padding: 30px;
          margin-top: 20px;
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.4);
          transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
        }

        .glass-card:hover {
          transform: scale(1.02);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.55);
        }

        /* Título con transparencia */
        .junaeb-title {
          display: inline-block;
          background: rgba(0, 0, 0, 0.45);
          border-radius: 12px;
          padding: 12px 24px;
          color: #fff;
          font-weight: bold;
          font-size: 1.8rem;
          text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
          backdrop-filter: blur(6px);
          -webkit-backdrop-filter: blur(6px);
          margin-bottom: 20px;
        }

        /* Texto principal */
        .glass-card p {
          font-size: 1.5rem; /* más grande y legible */
          line-height: 1.9;
          color: #f5f5f5;
          font-weight: 400;
        }
      `}</style>
    </section>
  );
}

export default Vision;
